import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Tooltip } from "@libs/rubick";
import { NodeHealthStatus } from "../types";
const getNodeColor = (status)=>{
    switch(status){
        case NodeHealthStatus.Healthy:
            return "bg-green-500";
        case NodeHealthStatus.Error:
            return "bg-red-500";
        case NodeHealthStatus.Offline:
            return "bg-gray-400";
    }
};
const getStatusLabel = (status)=>{
    switch(status){
        case NodeHealthStatus.Healthy:
            return "Healthy";
        case NodeHealthStatus.Error:
            return "Error";
        case NodeHealthStatus.Offline:
            return "Offline";
    }
};
const NodeTooltip = ({ node })=>/*#__PURE__*/ _jsxs("div", {
        className: "space-y-1.5 text-xs min-w-[280px]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-gray-400",
                        children: "Node ID:"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium truncate",
                        children: node.nodeId
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-gray-400",
                        children: "Status:"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium",
                        children: getStatusLabel(node.healthStatus)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "border-gray-600"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-gray-400",
                        children: "Type:"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium",
                        children: node.nodeType
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-gray-400",
                        children: "Location:"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium truncate",
                        children: node.location
                    })
                ]
            })
        ]
    });
export function NodeOverview({ nodes }) {
    const [tooltipBody, setTooltipBody] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({
        x: 0,
        y: 0
    });
    const handleHover = (description, event)=>{
        if (event?.type === "mousemove") {
            if (tooltipBody) {
                setTooltipPosition({
                    x: event.clientX,
                    y: event.clientY
                });
            }
            return;
        }
        setTooltipBody(description);
        if (event && description) {
            setTooltipPosition({
                x: event.clientX,
                y: event.clientY
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-1",
                children: nodes.map((node)=>/*#__PURE__*/ _jsx("div", {
                        className: `w-3 h-3 rounded-sm ${getNodeColor(node.healthStatus)} cursor-pointer transition-transform hover:scale-125`,
                        onMouseEnter: (event)=>handleHover(/*#__PURE__*/ _jsx(NodeTooltip, {
                                node: node
                            }), event),
                        onMouseMove: (event)=>handleHover(null, event),
                        onMouseLeave: ()=>handleHover(null)
                    }, node.nodeId))
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                description: tooltipBody,
                position: tooltipPosition
            })
        ]
    });
}
